import {Form} from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {Button} from '@/components'
import {POSFilterFooterProps} from './props'
import styles from './styles.scss'
import {APPLY_FILTER, CLOSE_FILTER} from '@/constants/playwright-ids'

export const FilterFooter: React.FC<POSFilterFooterProps> = ({formId, onClose}) => {
    const { t } = useTranslation()
    return (
        <>
            <Form.Item className={styles.footer}>
                <Button
                    onClick={onClose}
                    className={styles.close}
                    htmlType='button'
                    data-test-id={CLOSE_FILTER}
                    ghost
                >
                    {t('FilterFooter.close')}
                </Button>
                <Button type='primary' form={formId} htmlType='submit' data-test-id={APPLY_FILTER}>
                    {t('FilterFooter.apply')}
                </Button>
            </Form.Item>
        </>
    )
}
